import { Button } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import Mask from 'react-input-mask';
import { useHistory, useParams } from 'react-router-dom';
import { FontAwesome } from '..';
import { ESTADOS } from '../../constants/constants';
import { FEETYPESELECTS } from '../../constants/selects';
import useGetDistributorData from '../../hooks/distributors/useGetDistributorData';
import useRegisterDistributor from '../../hooks/distributors/useRegisterDistributor';
import useUpdateDistributor from '../../hooks/distributors/useUpdateDistributor';
import { DistributorForm } from '../../services/types';
import ActivityIndicator from '../ActivityIndicator';
import './styles.scss';
import { Formik } from 'formik';
import validationSchema from './validations';
import useViaCep from '../../utils/viaCep';

const FormDistributor: React.FC = () => {
  const { id } = useParams<{ id?: string }>();
  const history = useHistory();
  const { execute: executeViaCep } = useViaCep();
  const { execute: UseGetDistributor, loading: loadingDistributor } =
    useGetDistributorData();
  const { execute, loading } = useRegisterDistributor();
  const { execute: updateDistributor, loading: loadingUpdate } =
    useUpdateDistributor();
  const [distributor, setDistributor] = useState<DistributorForm>({
    name: '',
    email: '',
    cnpj: '',
    zipCode: '',
    state: '',
    city: '',
    neighborhood: '',
    streetAddress: '',
    streetNumber: '',
    phone: '',
    cellPhone: '',
    fee: '0',
    feeType: 'Percent',
    stateRegistration: ESTADOS[0].sigla,
  });

  const getDistributorData = async (id: string) => {
    const distributorData = await UseGetDistributor(id);
    setDistributor({
      ...distributorData,
    });
  };

  useEffect(() => {
    if (id?.length) {
      getDistributorData(id);
    } else {
      setDistributor({
        id: undefined,
        name: '',
        email: '',
        cnpj: '',
        zipCode: '',
        state: '',
        city: '',
        neighborhood: '',
        streetAddress: '',
        streetNumber: '',
        phone: '',
        cellPhone: '',
        fee: '0',
        feeType: 'Percent',
        stateRegistration: ESTADOS[0].sigla,
      });
    }
  }, [id]);

  const submitForm = async (values: DistributorForm) => {
    if (id) {
      await updateDistributor(values, id);
    } else {
      await execute(values);
    }
  };

  const handleViaCep = async (cep: string, values: DistributorForm) => {
    await executeViaCep(cep, (response: any) => {
      setDistributor({
        ...distributor,
        name: values.name,
        email: values.email,
        cnpj: values.cnpj,
        state: response.uf,
        city: response.localidade,
        neighborhood: response.bairro,
        zipCode: response.cep,
        streetAddress: response.logradouro,
        streetNumber: values.streetNumber,
        phone: values.phone,
        cellPhone: values.cellPhone,
        fee: values.fee,
        feeType:values.feeType,
      });
    });
  };

  if (loading || loadingDistributor || loadingUpdate) {
    return <ActivityIndicator />;
  }

  return (
    <div className="container-form-companie">
      <Formik
        initialValues={distributor}
        validationSchema={validationSchema}
        onSubmit={(values: DistributorForm) => {
          submitForm(values);
        }}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          touched,
          values,
          setValues,
          errors,
        }) => {
          useEffect(() => {
            setValues(distributor);
          }, [distributor, setValues]);
          return (
            <Form onSubmit={handleSubmit}>
              <Col className="container-body">
                <Form.Label>Nome *</Form.Label>
                <Form.Control
                  id="name"
                  value={values.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className="form-control"
                  maxLength={150}
                />
                {errors.name && touched.name && (
                  <div className="error-message">{errors.name}</div>
                )}
                <Form.Label>Email</Form.Label>
                <Form.Control
                  id="email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className="form-control"
                  maxLength={100}
                />
                {errors.email && touched.email && (
                  <div className="error-message">{errors.email}</div>
                )}
                <Form.Label>CNPJ *</Form.Label>
                <Form.Control
                  id="cnpj"
                  value={values.cnpj}
                  onChange={a => {
                    a.target.value = a.target.value.replace(/\D/g, '');
                    return handleChange(a);
                  }}
                  onBlur={handleBlur}
                  className="form-control"
                  as={Mask}
                  maskChar="_"
                  mask="99.999.999/9999-99"
                />
                {errors.cnpj && touched.cnpj && (
                  <div className="error-message">{errors.cnpj}</div>
                )}

                <Form.Label>CEP *</Form.Label>
                <Form.Control
                  id="zipCode"
                  value={values.zipCode}
                  onChange={(a: any) => {
                    a.target.value = a.target.value.replace(/\D/g, '');
                    return handleChange(a);
                  }}
                  className="form-control"
                  as={Mask}
                  maskChar="_"
                  mask="99999-999"
                  onBlur={(a: any) => {
                    const zipFormat = a.target.value.replace(/\D/g, '');
                    handleViaCep(zipFormat, values);
                  }}
                />
                {errors.zipCode && touched.zipCode && (
                  <div className="error-message">{errors.zipCode}</div>
                )}

                <Form.Label>Cidade *</Form.Label>
                <Form.Control
                  id="city"
                  value={values.city}
                  onChange={handleChange}
                  className="form-control"
                  maxLength={50}
                />
                {errors.city && touched.city && (
                  <div className="error-message">{errors.city}</div>
                )}

                <Form.Label>Bairro *</Form.Label>
                <Form.Control
                  id="neighborhood"
                  value={values.neighborhood}
                  onChange={handleChange}
                  className="form-control"
                  maxLength={100}
                />
                {errors.neighborhood && touched.neighborhood && (
                  <div className="error-message">{errors.neighborhood}</div>
                )}
                <Form.Label>Estado</Form.Label>
                <Form.Control
                  id="state"
                  as="select"
                  value={values.state}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className="form-control"
                >
                  {errors.state && touched.state && (
                    <div className="error-message">{errors.state}</div>
                  )}
                  {ESTADOS.map(option => (
                    <option value={option.sigla} key={option.codigoUf}>
                      {option.unidadeFederativa}
                    </option>
                  ))}
                </Form.Control>

                <Form.Label>Endereço da Empresa *</Form.Label>
                <Form.Control
                  id="streetAddress"
                  value={values.streetAddress}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className="form-control"
                  maxLength={150}
                />
                {errors.streetAddress && touched.streetAddress && (
                  <div className="error-message">{errors.streetAddress}</div>
                )}

                <Form.Label>Número *</Form.Label>
                <Form.Control
                  id="streetNumber"
                  value={values.streetNumber}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className="form-control"
                  maxLength={10}
                />
                {errors.streetNumber && touched.streetNumber && (
                  <div className="error-message">{errors.streetNumber}</div>
                )}

                <Form.Label>Telefone *</Form.Label>
                <Form.Control
                  id="phone"
                  value={values.phone}
                  onChange={a => {
                    a.target.value = a.target.value.replace(/\D/g, '');
                    return handleChange(a);
                  }}
                  onBlur={handleBlur}
                  className="form-control"
                  as={Mask}
                  maskChar="_"
                  mask="(99)99999-9999"
                />
                {errors.phone && touched.phone && (
                  <div className="error-message">{errors.phone}</div>
                )}
                <Form.Label> Whatsapp *</Form.Label>
                <Form.Control
                  id="cellPhone"
                  value={values.cellPhone}
                  onChange={a => {
                    a.target.value = a.target.value.replace(/\D/g, '');
                    return handleChange(a);
                  }}
                  onBlur={handleBlur}
                  className="form-control"
                  as={Mask}
                  maskChar="_"
                  mask="+99(99)99999-9999"
                />
                {errors.cellPhone && touched.cellPhone && (
                  <div className="error-message">{errors.cellPhone}</div>
                )}

                <Form.Label>Tipo de Taxa *</Form.Label>
                <Form.Control
                  id="feeType"
                  value={values.feeType}
                  as="select"
                  onChange={handleChange}
                  onBlur={handleBlur}
                >
                  {errors.feeType && touched.feeType && (
                    <div className="error-message">{errors.feeType}</div>
                  )}
                  {FEETYPESELECTS.map((option, index) => (
                    <option value={option.value} key={index}>
                      {option.name}
                    </option>
                  ))}
                </Form.Control>

                <Form.Label>Taxa *</Form.Label>
                <Form.Control
                  id="fee"
                  value={values.fee}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  maxLength={4}
                  className="form-control"
                />
                {errors.fee && touched.fee && (
                  <div className="error-message">{errors.fee}</div>
                )}
              </Col>
              <Row className="container-buttons" noGutters>
                <Button
                  className="primary-button outline"
                  onClick={() => history.goBack()}
                >
                  Voltar
                </Button>

                <Button type="submit" className="success-button icon-left">
                  <FontAwesome name="save" type="far" classname="fa-lg" />
                  {id?.length ? 'Editar' : 'Salvar'}
                </Button>
              </Row>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default FormDistributor;
